import i18n from 'i18next';
import en from './locales/en-US/react-cimpress-templates.json';
import de from './locales/de-DE/react-cimpress-templates.json';
import fr from './locales/fr-FR/react-cimpress-templates.json';
import it from './locales/it-IT/react-cimpress-templates.json';
import nl from './locales/nl-NL/react-cimpress-templates.json';
import ja from './locales/ja-JP/react-cimpress-templates.json';
import zh from './locales/zh-CN/react-cimpress-templates.json';
let i18nInstance = null;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getI18nInstance = () => {
    if (!i18nInstance) {
        i18nInstance = i18n.createInstance();
        i18nInstance
            .init({
            lng: 'en',
            fallbackLng: 'en',
            resources: {
                en: { 'translations': en },
                de: { 'translations': de },
                fr: { 'translations': fr },
                it: { 'translations': it },
                nl: { 'translations': nl },
                ja: { 'translations': ja },
                zh: { 'translations': zh },
            },
            ns: 'translations',
            defaultNS: 'translations',
            debug: false,
            interpolation: {
                escapeValue: false,
            },
            react: {
                wait: true,
            },
            saveMissing: true,
            missingKeyHandler: (lng, ns, key, fallbackValue) => {
                // eslint-disable-next-line no-console
                console.log(lng, ns, key, fallbackValue);
            },
        });
    }
    return i18nInstance;
};
//# sourceMappingURL=i18n.js.map